let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cDlUO")).then(() => parcelRequire('1P2v5'));